import React from 'react';
import { Grid, Typography, makeStyles } from '@material-ui/core';
import CheckIcon from '@material-ui/icons/Check';
import { colors } from 'design-system';

const useStyles = makeStyles({
  container: {
    padding: 32,
  },
  image: {
    marginTop: 15,
    marginBottom: 5,
  },
  icon: {
    color: colors.blue_zodiac,
    fontSize: 20,
  },
  containerDesc: {
    marginTop: 10,
  },
  paddingLeft5: {
    paddingLeft: 5,
  },
});

type Props = {
  titleMessage?: string;
  descriptionItems?: string[];
  image?: string;
};

const NotificationLayout = ({
  titleMessage,
  descriptionItems,
  image,
}: Props): JSX.Element => {
  const classes = useStyles();

  function makeRow(content: string): React.ReactNode {
    return (
      <Grid item container xs={12} key={content}>
        <Grid item xs={1}>
          <CheckIcon className={classes.icon} />
        </Grid>
        <Grid item xs={11}>
          <div className={classes.paddingLeft5}>
            <Typography variant="caption">{content}</Typography>
          </div>
        </Grid>
      </Grid>
    );
  }

  return (
    <div
      className={classes.container}
      id="sales-web-inspection-notification-layout"
    >
      <Grid container spacing={3}>
        <Grid item xs={12}>
          <img src="/images/assa_logo_blue.svg" alt="logo" />
        </Grid>
        <Grid
          className={classes.image}
          item
          xs={12}
          container
          justifyContent="center"
        >
          {image && (
            <img
              data-testid="render-image"
              src={`/images/${image}`}
              alt="Notification"
              title={image}
            />
          )}
        </Grid>
        <Grid item xs={12}>
          <Typography variant="body2" align="center">
            {titleMessage}
          </Typography>
        </Grid>

        <Grid
          data-testid="render-desc"
          className={classes.containerDesc}
          container
          spacing={2}
          justifyContent="center"
        >
          {descriptionItems &&
            descriptionItems.map(
              (element): React.ReactNode => makeRow(element),
            )}
        </Grid>
      </Grid>
    </div>
  );
};

export default NotificationLayout;
